<script>

import { onUnauthenticatedPages } from '@/util/routesHelper.js'

export default {
name: "LoadModelsMixin"
  ,
  data() {
    return {
      models_loaded: false,
      model_search: ''
    }
  },
  mounted() {
    this.load_models();
  },
  computed: {
    on_unauthenticated_pages() {
      return onUnauthenticatedPages.call(this);
    },
    models () {
      return this.$store.getters['model/get_items']
    },
    filtered_models () {
      const search = this.model_search.toLowerCase();
      return this.models.filter(model => {
        const matchesSearch = !search || model.name.toLowerCase().includes(search);
        return matchesSearch;
      });
    },
    active_models () {
      return this.filtered_models.filter(model => model.active && !model.archived);
    }
  },
  methods: {
    async load_models() {
      if(this.on_unauthenticated_pages || this.on_project_page) {
        return;
      }
      if(this.on_profile_page) {
        return;
      }
      await this.$store.dispatch('model/all')
      this.models_loaded = true
    },
    formatModelDisplay(model) {
      if (model.active && !model.archived) {
        return `${model.name} (active)`;
      }
      return model.name;
    }
  }
}
</script>

<style scoped>

</style>
